import { render, staticRenderFns } from "./YearStatisticComponent.vue?vue&type=template&id=070306bc&"
import script from "./YearStatisticComponent.vue?vue&type=script&lang=js&"
export * from "./YearStatisticComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports